<script>
	import Info from './test/Test2.svelte';
	import Header from './components/Header.svelte';
  import Footer from './components/Footer.svelte';
  import Background from './components/Background.svelte';
  import Routes from './Routes.svelte';
  import { setupI18n, isLocaleLoaded } from './services/i18n';
  
  $: if (!$isLocaleLoaded) {
    setupI18n(); // { withLocale: 'en' }
  }
</script>

{#if $isLocaleLoaded}
  <main>
    <Routes></Routes>
    <Footer />
  </main>
{:else}
  <div class="background-loading"></div>
  <div class="lds-css site-load">
    <div class="lds-eclipse">
      <div></div>
    </div>
    <div class="lds-loading"></div>
  </div>
{/if}

<Background></Background>